
import React from "react";
import { PagePlatform } from "@/types/page";
import { Laptop, Monitor, Smartphone } from "lucide-react";
import { 
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue 
} from "@/components/ui/select";

interface PlatformSelectorProps {
  platform: PagePlatform;
  onPlatformChange: (platform: PagePlatform) => void;
}

export const PlatformSelector: React.FC<PlatformSelectorProps> = ({ 
  platform, 
  onPlatformChange 
}) => {
  return (
    <div>
      <label className="block mb-2">פלטפורמה</label>
      <Select 
        value={platform} 
        onValueChange={(value: PagePlatform) => onPlatformChange(value)}
      >
        <SelectTrigger className="w-[150px]">
          <SelectValue placeholder="בחר פלטפורמה" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="both">
            <div className="flex items-center">
              <Laptop className="h-4 w-4 ml-2" />
              <span>שניהם</span>
            </div>
          </SelectItem>
          <SelectItem value="desktop">
            <div className="flex items-center">
              <Monitor className="h-4 w-4 ml-2" />
              <span>דסקטופ בלבד</span>
            </div>
          </SelectItem>
          <SelectItem value="mobile">
            <div className="flex items-center">
              <Smartphone className="h-4 w-4 ml-2" />
              <span>מובייל בלבד</span>
            </div>
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};
